const featuresData = [
    {
        heading : "Training Hub of the Future",
        paragraph :"Embark on a learning adventure with our cutting-edge IT training programs. Whether you're passionate about software testing, AI, development, digital marketing, or personal development, we've curated courses that propel you towards mastery. Our hands-on approach ensures you not only understand the concepts but also apply them with confidence."
    },
    {
        heading : "Internships and Certifications",
        paragraph :"Fuel your career with real-world experience through our internships. Top it off with certifications that speak volumes about your expertise. We believe in shaping not just learners but industry-ready professionals."
    },
    {
        heading : "Services that Transform",
        paragraph :"Beyond training, we're your strategic partners in success. Our services redefine possibilities"
    }
];

export default featuresData;